import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

const BarGraph = styled.div`
  background-color: #00b10082;
  border-radius: 2px;
`

const BarGraphContainer = styled.div`
  border: solid #aaa 1px;
  padding: 3px;
  border-radius: 4px;
  width: 100px;  
`

const Graphs = styled.div`
  display: flex;
  font-weight: bold;
  width: 100%;
  margin-right: 10px;
  margin-bottom: 20px;
  line-height: 14px;
`

const CompletionInfo = () => {
  const rules = useSelector(state => state.rules)
  const questions = useSelector(state => state.questions)

  const allRules = rules.flat()
  const checkedRules = allRules.filter(rule => rule.checked)
  const checkedQuestions = questions.filter(question => question.checked)

  return (
    <Graphs>
      <BarGraphContainer title={`${checkedRules.length} / ${allRules.length} Rules met`} style={{ borderColor: '#0C8CE6' }}>
        <BarGraph style={{ width: allRules.length === 0 ? 0 : `${checkedRules.length / allRules.length * 100}%`, backgroundColor: '#0C8CE6' }}>&nbsp;</BarGraph>
      </BarGraphContainer>
      <div style={{ marginLeft: 10, marginRight: 10, marginTop: 3 }} title={`${checkedRules.length} / ${allRules.length} Rules met`}>{checkedRules.length} / {allRules.length}</div>
      <BarGraphContainer title={`${checkedQuestions.length} / ${questions.length} Questions resolved`} style={{ borderColor: '#FF3B26' }}>
        <BarGraph style={{ width: questions.length === 0 ? 0 : `${checkedQuestions.length / questions.length * 100}%`, backgroundColor: '#FF3B26' }}>&nbsp;</BarGraph>
      </BarGraphContainer>
      <div style={{ marginLeft: 10, marginTop: 3 }} title={`${checkedQuestions.length} / ${questions.length} Questions resolved`}>{checkedQuestions.length} / {questions.length}</div>
    </Graphs>
  )
}

export default CompletionInfo
